import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    footer: {
        borderRadius: 15,
        margin: '30px 0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#FF9A00', 
        // font-family: "Audiowide", sans-serif,
      }
  }));